<template>
    <v-footer absolute app inset padless>
        <div class="footer-section">
            <div class="fixed-footer cf d-none d-lg-block d-md-none" style="text-align: -moz-center;text-align: -moz-center-or-inherit; text-align: -webkit-center;">
                <div class="container" style="padding: 0px !important;margin:0px">
                    <ul class="nav nav-tabs bg-tabs-content tabs-alt justify-content-center py-2" id="ulio">
                        <li class="nav-item">
                            Copyright © 2022
                            <a class="nav-link py-4 " href="https://www.birchequipment.com/" target="_blank">
                                Birch Equipment</a>
                        </li>
                        <span class="brand-color-1 brand-middot">
                            ·
                        </span>
                        <li class="nav-item">
                            <a class="nav-link py-4" href="https://www.birchequipment.com/privacy-policy/" target="_blank">Privacy Policy</a>
                        </li>
                        <span class="brand-color-1 brand-middot">
                            ·
                        </span>
                        <li class="nav-item">
                            <a class="nav-link py-4" href="https://www.birchequipment.com/terms-of-use/" target="_blank">Terms of Use</a>
                        </li>
                        <span class="brand-color-1 brand-middot">
                            ·
                        </span>
                        <li class="nav-item">
                            <a class="nav-link py-4" href="https://www.birchequipment.com/refund-policy/" target="_blank">Refund Policy</a>
                        </li>
                        <span class="brand-color-1 brand-middot">
                            ·
                        </span>
                        <li class="nav-item">
                            <a class="nav-link py-4" href="tel:1.866.722.4724">1.866.72.Birch</a>
                        </li>
                        <span class="brand-color-1 brand-middot">
                            ·
                        </span>
                        <li class="nav-item">
                            <a class="nav-link py-4" href="mailto:info@birchequipment.com">info@birchequipment.com</a>
                        </li>
                        <span class="brand-color-1 brand-middot">
                            ·
                        </span>
                        <li class="nav-item">
                            <a class="nav-link py-4" href="https://www.facebook.com/birchequipment/" target="_blank">
                                <v-icon color="white" size="20">
                                    mdi-facebook
                                </v-icon>
                            </a>
                        </li>
                        <span class="brand-color-1 brand-middot">
                            ·
                        </span>
                        <li class="nav-item">
                            <a class="nav-link py-4" href="https://twitter.com/birchequipment" target="_blank">
                                <v-icon color="white" size="20">
                                    mdi-twitter
                                </v-icon>
                            </a>
                        </li>
                        <span class="brand-color-1 brand-middot">
                            ·
                        </span>
                        <li class="nav-item">
                            <a class="nav-link py-4" href="https://www.linkedin.com/company/birch-equipment-rental-&amp;-sales" target="_blank">
                                <v-icon color="white" size="20">
                                    mdi-linkedin
                                </v-icon>
                            </a>
                        </li>
                        <span class="brand-color-1 brand-middot">
                            ·
                        </span>
                        <li class="nav-item">
                            Powered By
                            <a class="nav-link py-4" href="https://www.birchequipment.com/refund-policy/" target="_blank">
                                Incus5</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="fixed-footer  d-lg-none  d-md-block " style="text-align: -moz-center;text-align: -moz-center-or-inherit; text-align: -webkit-center; ">
                <div class="container fc td" style="padding: 0px 0 !important;margin:0px">
                    <ul class="nav nav-tabs bg-tabs-content tabs-alt justify-content-center py-2" id="ulio">
                        <li class="nav-item">
                            Copyright © 2022
                            <a class="nav-link py-4 " href="https://www.birchequipment.com/" target="_blank">
                                Birch Equipment</a>
                        </li>
                        <span class="brand-color-1 brand-middot">
                            ·
                        </span>
                        <li class="nav-item">
                            <a class="nav-link py-4" href="https://www.facebook.com/birchequipment/" target="_blank">
                                <v-icon color="white" size="20">
                                    mdi-facebook
                                </v-icon>
                            </a>
                        </li>
                        <span class="brand-color-1 brand-middot">
                            ·
                        </span>
                        <li class="nav-item">
                            <a class="nav-link py-4" href="https://twitter.com/birchequipment" target="_blank">
                                <v-icon color="white" size="20">
                                    mdi-twitter
                                </v-icon>
                            </a>
                        </li>
                        <span class="brand-color-1 brand-middot">
                            ·
                        </span>
                        <li class="nav-item">
                            <a class="nav-link py-4" href="https://www.linkedin.com/company/birch-equipment-rental-&amp;-sales" target="_blank">
                                <v-icon color="white" size="20">
                                    mdi-linkedin
                                </v-icon>
                            </a>
                        </li>
                        <span class="brand-color-1 brand-middot">
                            ·
                        </span>
                        <li class="nav-item">
                            Powered By
                            <a class="nav-link py-4" href="https://www.birchequipment.com/refund-policy/" target="_blank">
                                Incus5</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </v-footer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TheLayoutFooter",
  components: {},
  data: () => ({}),
  computed: {
    ...mapGetters(["footerShow"]),
  },
  props: ["isNavigationExpanded"],
  methods: {},
};
</script>
<style scoped lang="scss">
#ulio li
{
  display: inline;
  list-style-type: none;
  font-size: 13px!important;
 
}
.nav-tabs:not(.nav-fill):not(.nav-justified) .nav-link, .nav-pills:not(.nav-fill):not(.nav-justified) .nav-link {
    margin-right: .125rem;
}
.nav-tabs.tabs-alt .nav-link, .tabs-alt>.nav-tabs .nav-link {
    border-width: 0 !important;
    border-radius: 0 !important;
    background-color: transparent !important;
    color: white;
}
.nav-tabs .nav-link.active {
   color: white;
}
@import "../../assets/styles/variables.scss";
.brand-middot {
  padding: 0 2.5px;
}
.brand-color-1 {
  color: $neutral-blue-1;
}
.footer-section {
  width: 100%;
  // position: fixed;
  // margin-bottom: 2em;
}
.footer-section,
.footer-row-1 {
  background-color: $darker-grey !important;
  // border: none !important;
  min-height: 46px;
  border-top: 1px solid #e85a37bf;
}
.footer-row-1 {
  border-bottom: 1px solid $neutral-blue-1 !important;
}

</style>
